module.exports = { "default": require("core-js/library/fn/math/imul"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/imul.js
// module id = 1399
// module chunks = 2